export default {
  ALGORITHM: 'AES-256-GCM',
  // AAD 为接口约定的固定字符串，不随 keyVersion 变化
  AAD: 'store-settings:settlement-account:v1',
  NONCE_LENGTH: 12,
  KEY_MAP: {
    v1: 'kAaIvBV37rXkNxAUlVHMH3oaQmgIUQN1ZvpRf27EnUo='
  }
}
